<template>
  <div style="text-align: center;">
    <h1 style="
    font-size: 2.5rem;
    margin-bottom: 0.5rem;
    font-family: 'Basic',Helvetica,Arial,Lucida,sans-serif;
    font-weight: 500;
    line-height: 1.2;
    color: inherit;
    display: block;">Login</h1>
    <input type="text"      data-cy="email"     v-model="email" placeholder="Email"
      style="
        padding: 4px;
        border: 2px solid #55006D;
        font-family: 'Basic',Helvetica,Arial,Lucida,sans-serif;
        margin-top: 5px;
        margin-right: 5px;
        margin-left: 5px;
        margin-bottom: 5px;
        font-family: lato;
        font-size: large;
        line-height: inherit;
        width: 400px;
        height: 50px;
        font-style: normal;
        font-weight: 400;
        color: #55006D;
        border-radius: 4px;
        box-sizing: border-box;
        "
      ><br>
    <input type="password"  data-cy="senha"     v-model="senha" placeholder="Senha"
    style="
        padding: 4px;
        border: 2px solid #55006D;
        font-family: 'Basic',Helvetica,Arial,Lucida,sans-serif;
        margin-top: 5px;
        margin-right: 5px;
        margin-left: 5px;
        margin-bottom: 5px;
        font-family: lato;
        font-size: large;
        line-height: inherit;
        width: 400px;
        height: 50px;
        font-style: normal;
        font-weight: 400;
        color: #55006D;
        border-radius: 4px;
        box-sizing: border-box;
        "><br>
    <button @click="entrar" data-cy="entrar" style="
    color: #FFFFFF;
    font-family: lato;
    font-style: normal;
    font-weight: 400;
    background-color: #55006D;
    width: 400px;
    font-variant: normal;
    font-size: large;
    border-radius: 4px;
    line-height: normal;
    text-align: center;
    margin-top: 20px;
    border-color: #55006D;">Entrar</button>
    <div class="">
      <router-link to="/mf/forgot-password">Esqueci minha senha</router-link>
    </div>
  </div>
</template>


<script>
import { setupAxios } from '../../setupAxios';
import { loginDonator } from '../../apiClient';

export default {
  name: 'DonatorLogin',
  data: function () {
    return {
      email: '',
      senha: ''
    };
  },
  mounted () {
    this.axios = setupAxios();
  },
  methods: {
    async entrar () {
      const res = await loginDonator(this.axios, { email: this.email, password: this.senha });
      if (res.data) {
        this.saveUserToken(res.data);
        this.$router.push({ name: 'donator_home' });
        return;
      };

      alert("A senha inserida está incorreta. Tente novamente");
    },
    saveUserToken (data) {
      localStorage.setItem('token', data.token);
      localStorage.setItem('ttl', data.expires);
      localStorage.setItem('token_creation_ts', new Date().getTime());
    },
  }
};
</script>
